import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../../lib";
import { failureHash } from "./policy.static";
export class ApiEpBillingPolicy {
}
ApiEpBillingPolicy.setWorld = () => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/billing/policy/set-world`,
    method: "POST",
}, failureHash);
//# sourceMappingURL=policy.js.map